import React, { useEffect, useRef } from "react";

// SASS
import "./Part8.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import bubbleGroup1Img from "../../assets/img/bubbles_1.png";
import bubblesGroup2Img from "../../assets/img/bubbles_2.png";
import germ1Img from "../../assets/img/germ-1-brown.svg";
import germ2Img from "../../assets/img/germ-2-yellow.svg";
import targetImg from "../../assets/img/target.svg";

// FUNCTION EXPORT
export default function Part8({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "target germ2" },
    { stepNumber: "2", height: null, description: "target germ1" },
    { stepNumber: "3", height: null, description: "target germ2" },
    { stepNumber: "4", height: null, description: "spacer" },
  ];

  // REFS
  const targetEl = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.addClassOnEnter(targetEl.current, "target2", direction);
            break;
          }
          case "2": {
            animate.removeClassOnEnter(targetEl.current, "target2", direction);
            break;
          }
          case "3": {
            animate.addClassOnEnter(targetEl.current, "target2", direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.removeClassOnExit(targetEl.current, "target2", direction);
            break;
          }
          case "2": {
            animate.addClassOnExit(targetEl.current, "target2", direction);
            break;
          }
          case "3": {
            animate.removeClassOnExit(targetEl.current, "target2", direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part8">
          <div className="bubble bubble-1 float delay-random-1">
            <img src={bubbleGroup1Img} alt="" className="img-fluid" />
          </div>
          <div className="bubble bubble-2 float delay-random-2">
            <img src={bubblesGroup2Img} alt="" className="img-fluid" />
          </div>
          <div className="germ germ-1 rotate delay-random-3">
            <img src={germ2Img} alt="" className="img fluid" />
          </div>
          <div className="germ germ-2 rotate delay-random-4">
            <img src={germ1Img} alt="" className="img-fluid" />
          </div>
          <div className="text-box">
            <b>Contact time</b> <br />
            can vary depending on the disinfectant you are using and the germ
            you are targeting.
          </div>
          <div className="target" ref={targetEl}>
            <img src={targetImg} alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
